import { Image } from 'react-native'
import { Images as foundationImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

import background from '../Images/ShareAssets/instaStories'


const images = {
  logo: foundationImages.vfLogo,
  fall: Image.resolveAssetSource(
    require('./../Images/fall.png'),
  ),
  winter: Image.resolveAssetSource(
    require('./../Images/winter.png'),
  ),
  close: Image.resolveAssetSource(
    require('./../Images/close.png'),
  ),

  //hifi
  bundles: Image.resolveAssetSource(
    require('./../Images/HIFI/bundles.png'),
  ),
  celebrate: Image.resolveAssetSource(
    require('./../Images/HIFI/celebrate.png'),
  ),
  chat: Image.resolveAssetSource(
    require('./../Images/HIFI/chat.png'),
  ),
  lucky: Image.resolveAssetSource(
    require('./../Images/HIFI/lucky.png'),
  ),
  money: Image.resolveAssetSource(
    require('./../Images/HIFI/money.png'),
  ),
  rewardsClosed: Image.resolveAssetSource(
    require('./../Images/HIFI/rewardsClosed.png'),
  ),
  saving: Image.resolveAssetSource(
    require('./../Images/HIFI/saving.png'),
  ),

  //Mid Range
  chatMid: Image.resolveAssetSource(
    require('./../Images/Mid-render/chat.png'),
  ),
  coupon: Image.resolveAssetSource(
    require('./../Images/Mid-render/coupon.png'),
  ),
  priceTag: Image.resolveAssetSource(
    require('./../Images/Mid-render/priceTag.png'),
  ),
  flower: Image.resolveAssetSource(
    require('./../Images/Mid-render/flower.png'),
  ),
  rewards: Image.resolveAssetSource(
    require('./../Images/Mid-render/rewards.png'),
  ),
  VCoins: Image.resolveAssetSource(
    require('./../Images/Mid-render/VCoins.png'),
  ),
  warning: Image.resolveAssetSource(
    require('./../Images/Mid-render/warning.png'),
  ),

  quoteLeft: Image.resolveAssetSource(
    require('./../Images/Mid-render/quoteLeft.png'),
  ),
  quoteRight: Image.resolveAssetSource(
    require('./../Images/Mid-render/quoteRight.png'),
  ),


  //hifi
  lottie_bundles: require('./../Images/lottieIcons/smart.json'),
  lottie_celebrate: require('./../Images/lottieIcons/celebrate.json'),
  lottie_chat: require('./../Images/lottieIcons/chat.json'),
  lottie_promo: require('./../Images/lottieIcons/money.json'),
  lottie_data: require('./../Images/lottieIcons/reward.json'),
  lottie_coupon: require('./../Images/lottieIcons/redeem.json'),
  lottie_vcoins: require('./../Images/lottieIcons/coin.json'),

  info: Image.resolveAssetSource(
    require('./../Images/HIFI/info.png'),
  ),

  //base64
  shareBackground: background,

  //card
  fallCard: {
    topLeft: Image.resolveAssetSource(
      require('./../Images/card/fall/empty.png'),
    ),
    topRight: Image.resolveAssetSource(
      require('./../Images/card/fall/empty.png'),
    ),
    bottomLeft: Image.resolveAssetSource(
      require('./../Images/card/fall/empty.png'),
    ),
    bottomRight: Image.resolveAssetSource(
      require('./../Images/card/fall/empty.png'),
    ),
  },
  winterCard: {
    topLeft: Image.resolveAssetSource(
      require('./../Images/card/winter/topLeft.png'),
    ),
    topRight: Image.resolveAssetSource(
      require('./../Images/card/winter/topRight.png'),
    ),
    bottomLeft: Image.resolveAssetSource(
      require('./../Images/card/winter/bottomLeft.png'),
    ),
    bottomRight: Image.resolveAssetSource(
      require('./../Images/card/winter/bottomRight.png'),
    ),
  },
  topHeader: Image.resolveAssetSource(
    require('../../../../App/Assets/Images/web_header.png')
  ),
  webBackground: Image.resolveAssetSource(
    require('../../../../App/Assets/Images/web.png')
  ),
  webCard: {
  }

}

export default images

